import React from 'react';
import {
  CardContent,
  CardTitle,
  DefaultCard,
  DefaultContentText,
  DefaultSecondContentText,
  TitleText,
} from './styles';

export const CARD_COLOR = {
  GRAY: 'rgba(38, 52, 101, 0.08)',
  BLUE: 'var(--luft-primary)',
};

function DefaultCardItem({
  iconPath,
  title,
  contentText,
  secondContentText,
  color = CARD_COLOR.GRAY,
}) {
  return (
    <DefaultCard color={color}>
      <CardTitle>
        <div>
          <img src={iconPath} width="24px" height="24px" alt="Icon" />
        </div>
        <TitleText color={color}>{title}</TitleText>
      </CardTitle>
      <CardContent>
        <DefaultContentText color={color}>{contentText}</DefaultContentText>
        <DefaultSecondContentText color={color}>{secondContentText}</DefaultSecondContentText>
      </CardContent>
    </DefaultCard>
  );
}

export default DefaultCardItem;
